import { render, staticRenderFns } from "./AgentAIClient.vue?vue&type=template&id=1f4b347c&scoped=true"
import script from "./AgentAIClient.vue?vue&type=script&lang=js"
export * from "./AgentAIClient.vue?vue&type=script&lang=js"
import style0 from "./AgentAIClient.vue?vue&type=style&index=0&id=1f4b347c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f4b347c",
  null
  
)

export default component.exports